import React, { useState, useEffect, useRef } from "react";

import "../../css/MainReport.css";

import DropdownProblemType from "../Menu/DropdownProblemType";
import CreateMap from "../Menu/CreateMap";
import SecureStorage from "react-secure-storage";
import { saveDataLatLon } from "../../store/MapPositionSlice";

import noImg from "../../assets/image/no_select.png";

import { Modal } from "bootstrap";

import html2canvas from "html2canvas";
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';

import ic_porpor from "../../assets/icon/ic-porpor.png";
import ic_fondue from "../../assets/icon/ic-fondue.png";
import save from "../../assets/icon/save-icon.png";

import * as funcAll from "../../util/api";

///////////////// Redux ////////////////////
import { useSelector, useDispatch } from "react-redux";

export default function MainReportTH(props) {
  const globalData = useSelector((state) => ({ ...state }));
  const dispatch = useDispatch();

  const [detailReport, setDetailReport] = useState("");
  const [imgReport, setImgReport] = useState(noImg);
  const [reportMap, setReportMap] = useState(null);
  const inputFile = useRef(null);
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");

  const [listProblemTypeAll, setListProblemTypeAll] = useState([]);
  const [selectedProblemType, setSelectedProblemType] = useState([]);
  const [selectedOrganization, setSelectedOrganization] = useState(8662);

  const [alert_header, setAlertHeader] = useState(); //หัวข้อ alert
  const [alert_content, setAlertContent] = useState(); //รายละเอียก alert
  const [alert_description, setAlertDescription] = useState(); //รายละเอียก alert

  const modal_alert_ref = useRef(); //สำหรับ alert
  const [modal_alert_close, setModalAlertClose] = useState(null); //สำหรับ alert

  const modal_preview_ref = useRef(); //สำหรับ preview ก่อนแจ้ง
  const [modal_preview_close, setModalPreviewClose] = useState(null); //สำหรับ alert

  const modal_finish_card_ref = useRef(); //สำหรับ finish card หลังแจ้ง
  const [modal_finish_card_close, setModalFinishCardClose] = useState(null); //สำหรับ alert

  const [previewBtnDisabled, setPreviewBtnDisabled] = useState(false);

  const exportRef = useRef(null);

  const [resTicketId, setResTicketId] = useState("");
  const [resPassword, setResPassword] = useState("");

  useEffect(() => {
    getLocation();
  }, []);

  // useEffect(() => {
  //   setSelectedOrganization(8662);
  // },[])

  useEffect(() => {
    if (Object.keys(globalData.mapPosition.current_coors).length !== 0) {
      document.getElementById("location").style.display = "none";

      setReportMap(
        <div class="col-12 ">
          <CreateMap />
        </div>
      );
    } else {
      document.getElementById("location").style.display = "block";
    }
  }, [globalData.mapPosition.current_coors]);

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition);
    } else {
      // console.log("Geolocation is not supported by this browser.")
    }
  };

  const showPosition = async (position) => {
    let current_coors = {
      lng: position.coords.longitude,
      lat: position.coords.latitude,
    };
    await dispatch(saveDataLatLon(current_coors));
  };

  useEffect(() => {
    funcAll.getProblemType("th").then((res) => {
      if (res["status"] === true) {
        setListProblemTypeAll(res["results"]);
      } else {
      }
    });
  }, [selectedProblemType]);

  const handleDropdownProblemTypeChange = (selected) => {
    setSelectedProblemType(selected);
  };

  const onChangePicture = (e) => {
    if (e.target.files[0]) {
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setImgReport(reader.result);
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const handleClickUploadImg = (event) => {
    inputFile.current.click();
  };

  const handleBtnAlertClose = async () => {
    modalHide(modal_alert_close);
  };

  const handlePreviewClose = async () => {
    // console.log("preview close");
    modalHide(modal_preview_close);
  };

  const handleFinishCardClose = async () => {
    // console.log("finish card close");
    modalHide(modal_finish_card_close);
  };

  const modalShow = (mRef, setModals) => {
    const modal = new Modal(mRef.current, { keyboard: false });
    setModals(modal);
    modal.show();
  };

  const modalHide = (modal_hide) => {
    modal_hide.hide();
  };

  const alert_fail = (
    <span class="material-icons text-danger post-alert-icon my-3">cancel</span>
  );

  const setAlert = async (header_text, icon, description) => {
    setAlertHeader(header_text);
    setAlertContent(icon);
    setAlertDescription(description);
    modalShow(modal_alert_ref, setModalAlertClose);
  };

  const sendReportData = async (e) => {
    e.preventDefault();
    console.log("Success");
    // setDisableBtnSendData(true);
  };

  const view_Preview = (e) => {
    if (globalData.mapPosition.current_coors.length == 0) {
      setAlert(
        "ไม่สำเร็จ",
        alert_fail,
        "กรุณาอนุญาตให้เข้าถึงตำแหน่งปัจจุบันเพื่อแจ้งปัญหา"
      );
    } else if (detailReport.length < 1) {
      setTimeout(() => {
        setAlert("ไม่สำเร็จ", alert_fail, "กรุณากรอกรายละเอียดการแจ้ง");
      }, 1000);
    } else if (detailReport.length >= 1 && detailReport.length < 10) {
      setTimeout(() => {
        setAlert("ไม่สำเร็จ", alert_fail, "รายละเอียดสั้นเกินไป");
      }, 1000);
    } else if (selectedProblemType.length == 0) {
      setTimeout(() => {
        setAlert("ไม่สำเร็จ", alert_fail, "กรุณาเลือกประเภทเรื่องแจ้ง");
      }, 1000);
    } else if (imgReport == noImg) {
      setAlert("ไม่สำเร็จ", alert_fail, "กรุณาใส่รูปภาพการแจ้ง");
    } else {
      // console.log("ครบ");
      // console.log(
      //   "Problem Type : ",
      //   selectedProblemType["problem_types"][0]["name"]
      // );
      // console.log("Description : ", detailReport);
      // console.log("Img report : ", imgReport);
      // console.log("phone : ", phoneNumber);
      // console.log("email : ", email);

      // e.preventDefault()
      modalShow(modal_preview_ref, setModalPreviewClose);
    }
  };

  const view_Finish_Card = (e) => {
    // console.log("preview close & open finish card");
    // modalHide(modal_preview_close);
    // modalShow(modal_finish_card_ref, setModalFinishCardClose);

    funcAll
      .sendData(
        detailReport,
        selectedProblemType["problem_types"][0],
        imgReport,
        globalData.mapPosition.current_coors.lat,
        globalData.mapPosition.current_coors.lng,
        selectedOrganization,
        phoneNumber,
        email,
        "th"
      )
      .then((res) => {
        // console.log('res',res);
        // console.log('ticket_id',res["results"].ticket_id);
        // console.log('password',res["results"].password);

        if (res["status"] === "success") {
          // console.log("preview close & open finish card");

          modalHide(modal_preview_close);
          modalShow(modal_finish_card_ref, setModalFinishCardClose);

          setResTicketId(res["results"].ticket_id);
          setResPassword(res["results"].password);
        } else if (res["status"] == "fail") {
          setAlert("Failed", alert_fail, "Please try again");
        }
      });

    // console.log("submit Button clicked!");

    setPreviewBtnDisabled(true);
  };

  const DownloadTicketCard = (domElement) => {
    html2canvas(domElement).then((canvas) => {
      const image = canvas.toDataURL("png");
      const a = document.createElement("a");
      a.setAttribute("download", "ticket-card.png");
      a.setAttribute("href", image);
      a.click();

      // console.log(a);
      // console.log(image);
    });
  };

  return (
    <div className="report-container">
      <form
        id="myform"
        class="needs-validation"
        novalidate
        onSubmit={sendReportData}
      >
        <div className="container-title">
          <p className="txt-th title">รายละเอียดการแจ้ง</p>
          <p className="txt-th sub-title">(กรุณาแจ้งรายละเอียดให้ครบถ้วน)</p>
        </div>

        <div className="was-validated">
          <textarea
            required
            type="text"
            className="form-control shadow-style input"
            rows="6"
            minLength={10}
            value={detailReport}
            onChange={(e) => setDetailReport(e.target.value)}
            placeholder="กรุณาพิมพ์รายละเอียดที่ต้องการแจ้ง  เพื่อให้เจ้าหน้าที่ได้ข้อมูลเพียงพอ ควรกรอกอย่างน้อย 10 คำ เช่น พบเห็นควันดำ ใกล้ๆ ซอย A ไม่แน่ใจว่ามีเหตุไฟไหม้หรือควันดำจากอะไร"
          />
        </div>

        <div className="container-title pt-5">
          <p className="txt-th title">ช่องทางให้เจ้าหน้าที่ติดต่อสอบถามเพิ่มเติม </p>
        </div>

        <div className="container-title">
          <input
            type="text"
            class="form-control shadow-style"
            placeholder="เบอร์มือถือ/บ้าน/ที่ทำงาน (ได้หลายเบอร์) ช่วงเวลาที่สะดวก ฯลฯ"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
          ></input>
        </div>

        <div className="container-title pt-5">
          <p className="txt-th title">อีเมล </p>
        </div>

        <div className="container-title">
          <input
            type="text"
            class="form-control shadow-style"
            placeholder="เช่น abc@mail.com (อีเมลเดียวเท่านั้น)"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          ></input>
        </div>

        <div
          className={`${listProblemTypeAll.length == 0 ? "disable-div" : ""}`}
        >
          <div className="container-title pt-5">
            <p className="txt-th title">ประเภทเรื่องแจ้ง</p>
          </div>

          <DropdownProblemType
            options={listProblemTypeAll}
            onSelect={handleDropdownProblemTypeChange}
            selectedOption={selectedProblemType}
            placeholder="เลือกประเภทปัญหา"
          />
        </div>

        <div className="container-title pt-5">
          <p className="txt-th title">ตำแหน่งที่เกิดเหตุ</p>
          <p className="txt-th sub-title">
            (พิมพ์สถานที่ หรือ คลิกแผนที่ เพื่อเลือกตำแหน่งที่ต้องการ)
          </p>
        </div>

        {/* ******** ส่วนของตัวเตือนเปิด Location ********** */}

        <div id="location">
          <div class="text-left bg-danger text-white p-2 d-flex justify-content-center">
            <span class="material-icons pe-2">error_outline</span>
            กรุณาอนุญาตให้เข้าถึงตำแหน่งปัจจุบันเพื่อแจ้งปัญหา
            <br />
            <br />
            - สำหรับ Android : แตะที่รูปกุญแจ บนแถบด้านบน
            (อยู่ด้านซ้ายของเว็บไซต์) -&gt; "การอนุญาต"/"Permissions" -&gt;
            เลื่อนเปิด "ตำแหน่ง"/"Location" -&gt; Reload/Refresh
            หน้าเว็บอีกครั้ง
            <br />
            <br />
            - สำหรับ iPhone/iPad : หากกดไม่อนุญาติไปแล้ว
            ยังไม่มีวิธีปลดบล็อกตำแหน่ง
            <br />
            <br />- สำหรับ Windows : คลิกที่รูปกุญแจ บนแถบด้านบน
            (อยู่ด้านซ้ายของเว็บไซต์) -&gt; เลื่อนเปิด "ตำแหน่ง"/"Location"
            หรือเลือก "Allow" -&gt; Reload/Refresh หน้าเว็บอีกครั้ง
          </div>
        </div>

        {/* ******** ส่วนของตัวเตือนเปิด Location ********** */}

        {reportMap}

        <div className="container-title pt-5">
          <p className="txt-th title">รูปภาพปัญหาที่พบ</p>
        </div>

        <div className="container-bg-img-report mt-2 mb-5">
          <img
            className={`img-report ${imgReport != noImg ? "have-img" : ""}`}
            src={imgReport}
            onClick={handleClickUploadImg}
          />
          <div className="btn-add-img" onClick={handleClickUploadImg}>
            <p className="txt-th">เพิ่มรูปภาพ</p>
          </div>
          <input
            type="file"
            id="file"
            required
            onChange={onChangePicture}
            ref={inputFile}
            accept="image/*"
            style={{ display: "none" }}
          />
        </div>

        <button
          className="btn-report"
          // type="submit"
          onClick={view_Preview}
        >
          <p>แจ้งปัญหา</p>
        </button>

        {/* ******* ส่วนของ popup preview ************* */}
        <div
          class="modal fade"
          ref={modal_preview_ref}
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered modal-dialog-custom">
            <div class="modal-content">
              <div className="modal-body text-center p-0">
                <p className="title-preview mt-3">ตัวอย่างการแจ้ง</p>
              </div>

              <div class="container-detail-preview2">
                <div className="container-sub-detail-preview mt-3">
                  <p className="sub-title">ประเภทปัญหา</p>
                  {selectedProblemType.length != 0 ? (
                    <>
                      {" "}
                      <p className="sub-title-detail">
                        {selectedProblemType["problem_types"][0]["name"]}
                      </p>
                    </>
                  ) : null}
                </div>

                <div className="container-sub-detail-preview mt-2">
                  <p className="sub-title">รายละเอียด</p>
                  <p className="sub-title-detail">{detailReport}</p>
                </div>

                {phoneNumber.length != 0 ? (
                  <>
                    <div className="container-sub-detail-preview mt-2">
                      <p className="sub-title">
                        เบอร์โทรศัพท์
                      </p>{" "}
                      <p className="sub-title-detail">{phoneNumber}</p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="container-sub-detail-preview mt-0">
                      <p className="sub-title-none">
                        เบอร์โทรศัพท์
                      </p>{" "}
                      <p className="sub-title-detail-none">{phoneNumber}</p>
                    </div>
                  </>
                )}

                {email.length != 0 ? (
                  <>
                    <div className="container-sub-detail-preview mt-2">
                      <p className="sub-title">อีเมล</p>
                      {" "}
                      <p className="sub-title-detail">{email}</p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="container-sub-detail-preview mt-0">
                      <p className="sub-title-none">อีเมล</p>
                      {" "}
                      <p className="sub-title-detail-none">{email}</p>
                    </div>
                  </>
                )}

                <div className="container-sub-detail-preview mt-2">
                  <p className="sub-title">หน่วยงานรับเรื่อง</p>
                  <p className="sub-title-detail">
                    กรมป้องกันและบรรเทาสาธารณภัย
                  </p>
                </div>

                <div className="container-preview-img-report mt-2">
                  <p>รูปภาพปัญหา</p>
                  <img src={imgReport}></img>
                </div>

                <div className="container-btn-preview mt-3">
                  <a className="btn-cancel" onClick={handlePreviewClose}>
                    <p>ย้อนกลับ</p>
                  </a>

                  <button
                    className="btn-report"
                    // type="submit"
                    onClick={view_Finish_Card}
                    disabled={previewBtnDisabled}
                  >
                    <p>แจ้งปัญหา</p>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ******* ส่วนของ popup preview ************* */}

        {/* ******* ส่วนของ popup finish card ************* */}
        <div
          class="modal fade"
          ref={modal_finish_card_ref}
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered modal-dialog-custom">
            <div class="modal-content modal-content-finish-card">
              <div className="parent" ref={exportRef} id="finish-card">
                <div className="modal-body modal-body-header text-center">
                  <div className="finish-card-logo">
                    <img className="logo-traffy mt-3" src={ic_porpor}></img>
                    <img className="logo-fondue-app mt-3" src={ic_fondue}></img>
                  </div>
                  <p className="header-finish-card my-2">
                    ขอบคุณที่แจ้งปัญหากับเรา!
                  </p>
                  <p className="header-finish-card-detail mb-1">
                    เรื่องแจ้งของท่านเข้าสู่ระบบแล้ว
                  </p>
                  <p className="header-finish-card-detail">
                    ขอบคุณที่ทำให้เมืองของเราน่าอยู่มากขึ้น
                  </p>
                </div>

                <div className="modal-body-ticket text-center p-0">
                  <p className="title-finish-card mt-3">
                    Ticket ID: {resTicketId}
                  </p>
                </div>

                <div class="container-detail-finish-card2">
                  <div className="container-sub-detail-preview mt-3">
                    <p className="sub-title">ประเภทปัญหา</p>
                    {selectedProblemType.length != 0 ? (
                      <>
                        {" "}
                        <p className="sub-title-detail">
                          {selectedProblemType["problem_types"][0]["name"]}
                        </p>
                      </>
                    ) : null}
                  </div>

                  <div className="container-sub-detail-preview mt-2">
                    <p className="sub-title">รายละเอียด</p>
                    <p className="sub-title-detail">{detailReport}</p>
                  </div>

                  {/* <div className="container-sub-detail-preview mt-2"> */}
                  {/* <p className="sub-title">Phone number</p> */}
                  {phoneNumber.length != 0 ? (
                    <>
                      <div className="container-sub-detail-preview mt-2">
                        <p className="sub-title">เบอร์โทรศัพท์</p>
                        {" "}
                        <p className="sub-title-detail">{phoneNumber}</p>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="container-sub-detail-preview mt-0">
                        <p className="sub-title-none">เบอร์โทรศัพท์</p>
                        {" "}
                        <p className="sub-title-detail-none">{phoneNumber}</p>
                      </div>
                    </>
                  )}
                  {/* </div> */}

                  {/* <div className="container-sub-detail-preview mt-2"> */}
                  {/* <p className="sub-title">Email</p> */}
                  {email.length != 0 ? (
                    <>
                      <div className="container-sub-detail-preview mt-2">
                        <p className="sub-title">อีเมล</p>
                        {" "}
                        <p className="sub-title-detail">{email}</p>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="container-sub-detail-preview mt-0">
                        <p className="sub-title-none">อีเมล</p>
                        {" "}
                        <p className="sub-title-detail-none">{email}</p>
                      </div>
                    </>
                  )}
                  {/* </div> */}

                  <div className="container-sub-detail-preview mt-2">
                    <p className="sub-title">หน่วยงานรับเรื่อง</p>
                    <p className="sub-title-detail">
                      กรมป้องกันและบรรเทาสาธารณภัย
                    </p>
                  </div>

                  <div className="container-preview-img-report mt-2">
                    <p>รูปภาพปัญหา</p>
                    <img src={imgReport}></img>
                  </div>

                  <div className="container-btn-save-social mt-2">
                    <a
                      className="btn-save-share"
                      type="button"
                      onClick={() => DownloadTicketCard(exportRef.current)}
                    >
                      <img className="btn-save-img" src={save} />
                    </a>
                  </div>

                  <div className="container-password-follow-up mt-3">
                    <p className="sub-title-detail-follow">
                      ติดตามความคืบหน้าเรื่องแจ้งของท่านได้ที่
                    </p>
                    <p className="sub-title-detail-link">
                      https://c.traffy.in.th/{resTicketId}
                    </p>
                    <p className="sub-title-detail-password">
                      รหัสติดตามเรื่อง {resPassword}
                    </p>
                  </div>

                  <div className="container-alert-follow-up mt-3 mb-3">
                    <p className="sub-title">
                      *โปรดบันทึกหรือจด Ticket ID และ รหัสติดตามเรื่อง
                    </p>
                    <p className="sub-title-detail">
                      เพื่อใช้ติดตามสถานะการทำงาน
                    </p>
                  </div>
                </div>
              </div>

              <div className="container-btn-finish-card mt-3">
                <a
                  // type="submit"
                  className="btn-finish-card"
                  onClick={handleFinishCardClose}
                >
                  <p>เสร็จสิ้น</p>
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* ******* ส่วนของ popup finish card ************* */}
      </form>

      {/* ******* ส่วนของ Alert ************* */}
      <div
        className="modal fade"
        ref={modal_alert_ref}
        id="stateUpdate"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content bg-transparent border-0">
            <div className="modal-body text-center">
              <div className="d-flex justify-content-center">
                <div className="card post-alert-box rounded-4">
                  <div className="card-body">
                    <p className="card-text p-0 m-0">{alert_content}</p>
                    <h4 className="txt-title-alert">{alert_header}</h4>
                    <h6 className="txt-detail-alert">{alert_description}</h6>
                    <button
                      type="button"
                      className="btn-alert"
                      onClick={handleBtnAlertClose}
                    >
                      <p>ตกลง</p>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ******* ส่วนของ Alert ************* */}
    </div>
  );
}
